import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import AdminPage from './pages/AdminPage'
import UsersPage from './pages/admin/UsersPage'
import OrganizationsPage from './pages/admin/OrganizationsPage'
import MemberManagementPage from './pages/admin/MemberManagementPage'
import AccountPage from './pages/admin/AccountPage'
import ChangePasswordPage from './pages/admin/ChangePasswordPage'
import AdminLogin from './pages/AdminLogin'
import AdminResetPassword from './pages/AdminResetPassword'
import PointsManagementPage from './pages/admin/services/PointsManagementPage'
import ReferralManagementPage from './pages/admin/services/ReferralManagementPage'
import RedemptionManagementPage from './pages/admin/services/RedemptionManagementPage'
import PluginPage from './pages/admin/PluginPage'
import PartnersPage from './pages/admin/PartnersPage'
import PartnerDetailPage from './pages/admin/PartnerDetailPage'
import ErrorBoundary from './components/ErrorBoundary'

import { Navigate } from 'react-router-dom';

function App() {
  // Helper function to check if user is logged in
  const checkAuth = () => {
    const adminToken = localStorage.getItem('cnxn_admin_token');
    return !!adminToken;
  };
  
  return (
    <ErrorBoundary>
      <Router>
        <div style={{ padding: '20px' }}>
          <Routes>
            {/* Redirect root to dashboard if authenticated, otherwise to login */}
            <Route path="/" element={
              checkAuth() ? <AdminPage /> : <Navigate to="/admin/login" />
            } />
            
            {/* Main admin routes */}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/admin/organizations" element={<OrganizationsPage />} />
            <Route path="/admin/organizations/:orgId/manage" element={<MemberManagementPage />} />
            <Route path="/admin/partners" element={<PartnersPage />} />
            <Route path="/admin/partners/:partnerId" element={<PartnerDetailPage />} />
            <Route path="/admin/account" element={<AccountPage />} />
            <Route path="/admin/change-password" element={<ChangePasswordPage />} />
            <Route path="/admin/plugin" element={<PluginPage />} />
            <Route path="/admin/services/points" element={<PointsManagementPage />} />
            <Route path="/admin/services/referral" element={<ReferralManagementPage />} />
            <Route path="/admin/services/redemption" element={<RedemptionManagementPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App